export const downsampleBuffer = (buffer, sampleRate, targetSampleRate) => {
  if (targetSampleRate === sampleRate) return buffer;
  if (targetSampleRate > sampleRate) {
    console.error("Target sample rate must be lower than original sample rate");
    return buffer;
  }
  
  const sampleRateRatio = sampleRate / targetSampleRate;
  const newLength = Math.round(buffer.length / sampleRateRatio);
  const result = new Float32Array(newLength);
  let offsetResult = 0;
  let offsetBuffer = 0;
  
  while (offsetResult < newLength) {
    const nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
    let accum = 0;
    let count = 0;
    
    for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
      accum += buffer[i];
      count++;
    }
    
    result[offsetResult] = count ? accum / count : 0;
    offsetResult++;
    offsetBuffer = nextOffsetBuffer;
  }
  
  return result;
};

export const floatTo16BitPCM = (input) => {
  const output = new Int16Array(input.length);
  
  for (let i = 0; i < input.length; i++) {
    let s = Math.max(-1, Math.min(1, input[i]));
    output[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
  }
  
  return output.buffer;
};
